import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PERSIST, PAUSE, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import WorkStationReducer from './apps/content/WorkStationSlice'
import LessonReducer from './apps/content/LessonSlice'

import LoginReducer from './apps/login/LoginSlice';

import CustomizerReducer from './customizer/CustomizerSlice';
import ChatsReducer from './apps/chat/ChatSlice';
import NotesReducer from './apps/notes/NotesSlice';
import EmailReducer from './apps/email/EmailSlice';
import TicketReducer from './apps/tickets/TicketSlice';
import ContactsReducer from './apps/contacts/ContactSlice';
import EcommerceReducer from './apps/eCommerce/EcommerceSlice';
import UserProfileReducer from './apps/userProfile/UserProfileSlice';
import BlogReducer from './apps/blog/BlogSlice';


const persistConfig = {
  key: 'root', // Persist edilecek state'lerin anahtar değeri
  storage, // State'lerin saklanacağı yer (localStorage)
  ignoredActions: ['persist/PERSIST'], // PERSIST eylemini yok sayın
};

const persistedReducer = persistReducer(persistConfig, combineReducers({
  loginReducer: LoginReducer,
  workStationReducer: WorkStationReducer,
  lessonReducer:LessonReducer,

  customizer: CustomizerReducer,
  chatReducer: ChatsReducer,
  emailReducer: EmailReducer,
  notesReducer: NotesReducer,
  contactsReducer: ContactsReducer,
  ticketReducer: TicketReducer,
  ecommerceReducer: EcommerceReducer,
  userpostsReducer: UserProfileReducer,
  blogReducer: BlogReducer,

}));

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
